/* ============================================================================
   ag-search-overlay.js
   Full-screen search overlay with:
   - Gender toggle (configurable default + order)
   - Popular searches (always visible in default state)
   - Product grid from selected gender collection on open
   - Search results replace grid when user types
   ============================================================================ */

(function() {
  'use strict';

  var searchEl = document.getElementById('Search');
  if (!searchEl) return;

  var resultsEl = searchEl.querySelector('.Search__Results');
  if (!resultsEl) return;

  var inputEl = searchEl.querySelector('[name="q"]');

  /* === Config === */
  var configEl = document.querySelector('[data-ag-search-config]');
  var popularSearches = [];
  var womensUrl = '/collections/all-women';
  var mensUrl = '/collections/all-men';
  var defaultGender = 'women';
  var genderOrder = 'women_first';

  if (configEl) {
    try { popularSearches = JSON.parse(configEl.dataset.agSearchPopular || '[]'); } catch(e) {}
    womensUrl = configEl.dataset.agSearchWomens || womensUrl;
    mensUrl = configEl.dataset.agSearchMens || mensUrl;
    defaultGender = configEl.dataset.agSearchDefault || defaultGender;
    genderOrder = configEl.dataset.agSearchOrder || genderOrder;
  }

  var hideOos = configEl && configEl.dataset.agSearchHideOos === 'true';

  /* === OOS helpers === */
  function filterOosCards(container) {
    container.querySelectorAll('.ag-card').forEach(function(card) {
      var soldBadge = card.querySelector('.ag-card__badge--sold');
      var comingSoon = card.querySelector('.ag-card__badge--soon');
      if (soldBadge && !comingSoon) card.remove();
    });
  }

  function updateVisibleCount(container) {
    var visibleCards = container.querySelectorAll('.ag-grid .ag-card').length;
    var countEl = container.querySelector('.ag-search-count');
    if (countEl) {
      var title = countEl.textContent.replace(/^\d+/, '');
      /* Extract collection title from text like " products in All Womens Outerwear" */
      var match = title.match(/products?\s+in\s+(.+)/i);
      var collTitle = match ? match[1].trim() : '';
      countEl.textContent = visibleCards + ' product' + (visibleCards !== 1 ? 's' : '') + (collTitle ? ' in ' + collTitle : '');
    }
    /* Update progress count */
    var progressCount = container.querySelector('.ag-search-load-more__count');
    if (progressCount) {
      var strongs = progressCount.querySelectorAll('strong');
      if (strongs.length >= 1) strongs[0].textContent = visibleCards;
    }
  }

  var activeGender = null;

  function genderUrl(gender) {
    return gender === 'women' ? womensUrl : mensUrl;
  }

  /* === Build gender bar (respects order setting) === */
  function genderButton(gender) {
    var label = gender === 'women' ? 'WOMEN' : 'MEN';
    var active = activeGender === gender ? ' is-active' : '';
    return '<button type="button" class="ag-search-gender__btn' + active + '" data-ag-gender="' + gender + '"><span class="ag-search-gender__box"></span> ' + label + '</button>';
  }

  function buildGenderBar() {
    var first = genderOrder === 'men_first' ? 'men' : 'women';
    var second = first === 'women' ? 'men' : 'women';
    return '<div class="ag-search-gender">' + genderButton(first) + genderButton(second) + '</div>';
  }

  /* === Build popular searches === */
  function buildPopular() {
    if (popularSearches.length === 0) return '';
    var html = '<div class="ag-search-popular">';
    html += '<p class="ag-search-popular__label">Popular Searches</p>';
    html += '<ul class="ag-search-popular__list">';
    popularSearches.forEach(function(term) {
      html += '<li class="ag-search-popular__item">';
      html += '<a href="#" class="ag-search-popular__link" data-ag-popular-search="' + term.replace(/"/g, '&quot;') + '">\u2018' + term + '\u2019</a>';
      html += '</li>';
    });
    html += '</ul></div>';
    return html;
  }

  /* === Auto-load more pages if OOS filtering leaves too few visible === */
  function autoLoadMore(gridContainer, minVisible) {
    if (!hideOos) return;
    var grid = gridContainer.querySelector('.ag-grid');
    if (!grid) return;
    var visible = grid.querySelectorAll('.ag-card').length;
    if (visible >= minVisible) return;

    var loadBtn = gridContainer.querySelector('[data-ag-search-load-more]');
    if (!loadBtn) return;
    var nextUrl = loadBtn.dataset.nextUrl;
    if (!nextUrl) return;

    fetch(nextUrl, { credentials: 'same-origin' })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newCards = doc.querySelectorAll('.ag-card');
        if (newCards.length > 0) {
          newCards.forEach(function(card) { grid.appendChild(card); });
          filterOosCards(grid);
          grid.querySelectorAll('.ag-card__size:not([data-original-text])').forEach(function(btn) {
            btn.dataset.originalText = btn.textContent;
          });
        }
        /* Update load-more button */
        var newLoadMore = doc.querySelector('.ag-search-load-more');
        var currentLoadMore = gridContainer.querySelector('.ag-search-load-more');
        if (currentLoadMore && newLoadMore) {
          currentLoadMore.innerHTML = newLoadMore.innerHTML;
        } else if (currentLoadMore) {
          currentLoadMore.style.display = 'none';
        }
        updateVisibleCount(gridContainer);
        /* Keep going if still not enough */
        autoLoadMore(gridContainer, minVisible);
      })
      .catch(function() {});
  }

  /* === Load collection grid === */
  function loadGenderGrid(gender) {
    activeGender = gender;
    var gridContainer = resultsEl.querySelector('.ag-search-grid');
    if (!gridContainer) return;

    gridContainer.innerHTML = '<div class="ag-search-count" style="padding:12px 0 0;">Loading...</div>';

    fetch(genderUrl(gender) + '?view=search-overlay', { credentials: 'same-origin' })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        gridContainer.innerHTML = html;
        /* Filter out sold-out products if configured */
        if (hideOos) {
          filterOosCards(gridContainer);
          updateVisibleCount(gridContainer);
          /* Auto-load more pages if too few visible (aim for at least 8) */
          autoLoadMore(gridContainer, 8);
        }
        gridContainer.querySelectorAll('.ag-card__size:not([data-original-text])').forEach(function(btn) {
          btn.dataset.originalText = btn.textContent;
        });
        resultsEl.querySelectorAll('[data-ag-gender]').forEach(function(btn) {
          btn.classList.toggle('is-active', btn.dataset.agGender === activeGender);
        });
      })
      .catch(function() {
        gridContainer.innerHTML = '<div class="ag-search-count" style="padding:12px 0 0;">Failed to load.</div>';
      });
  }

  /* === Default state === */
  function buildDefaultState() {
    return buildGenderBar() + buildPopular() + '<div class="ag-search-grid"></div>';
  }

  function showDefault() {
    activeGender = defaultGender;
    resultsEl.innerHTML = buildDefaultState();
    resultsEl.setAttribute('aria-hidden', 'false');
    resultsEl.querySelectorAll('[data-ag-gender]').forEach(function(btn) {
      btn.classList.toggle('is-active', btn.dataset.agGender === activeGender);
    });
    loadGenderGrid(defaultGender);
  }

  /* === Observe open/close === */
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.attributeName === 'aria-hidden') {
        if (searchEl.getAttribute('aria-hidden') === 'false') {
          document.body.classList.add('ag-search-open');
          showDefault();
        } else {
          document.body.classList.remove('ag-search-open');
          activeGender = null;
        }
      }
    });
  });
  observer.observe(searchEl, { attributes: true, attributeFilter: ['aria-hidden'] });

  /* === Click handler === */
  resultsEl.addEventListener('click', function(e) {

    /* Gender toggle */
    var genderBtn = e.target.closest('[data-ag-gender]');
    if (genderBtn) {
      e.preventDefault();
      e.stopPropagation();
      var gender = genderBtn.dataset.agGender;
      if (activeGender === gender) return;

      if (inputEl) inputEl.value = '';
      activeGender = gender;
      resultsEl.innerHTML = buildDefaultState();
      resultsEl.querySelectorAll('[data-ag-gender]').forEach(function(btn) {
        btn.classList.toggle('is-active', btn.dataset.agGender === activeGender);
      });
      loadGenderGrid(gender);
      return;
    }

    /* Popular search */
    var popLink = e.target.closest('[data-ag-popular-search]');
    if (popLink) {
      e.preventDefault();
      if (inputEl) {
        inputEl.value = popLink.dataset.agPopularSearch;
        inputEl.dispatchEvent(new Event('input', { bubbles: true }));
        inputEl.focus();
      }
      return;
    }

    /* Load more */
    var loadBtn = e.target.closest('[data-ag-search-load-more]');
    if (loadBtn) {
      e.preventDefault();
      var nextUrl = loadBtn.dataset.nextUrl;
      if (!nextUrl) return;

      loadBtn.disabled = true;
      loadBtn.textContent = 'LOADING...';

      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('.ag-card');
          var grid = resultsEl.querySelector('.ag-grid');

          if (grid && newCards.length > 0) {
            newCards.forEach(function(card) { grid.appendChild(card); });
            /* Filter OOS from newly loaded cards */
            if (hideOos) filterOosCards(grid);
            grid.querySelectorAll('.ag-card__size:not([data-original-text])').forEach(function(btn) {
              btn.dataset.originalText = btn.textContent;
            });
          }

          var newLoadMore = doc.querySelector('.ag-search-load-more');
          var currentLoadMore = resultsEl.querySelector('.ag-search-load-more');
          if (currentLoadMore && newLoadMore) {
            currentLoadMore.innerHTML = newLoadMore.innerHTML;
          } else if (currentLoadMore) {
            currentLoadMore.style.display = 'none';
          }
          /* Update visible count after load more */
          if (hideOos) {
            var gridContainer = resultsEl.querySelector('.ag-search-grid');
            if (gridContainer) updateVisibleCount(gridContainer);
          }
        })
        .catch(function() {
          loadBtn.textContent = 'ERROR';
          loadBtn.disabled = false;
        });
      return;
    }
  });

  /* === When Prestige injects search results, ensure visible === */
  var resultsObserver = new MutationObserver(function() {
    resultsEl.setAttribute('aria-hidden', 'false');
  });
  resultsObserver.observe(resultsEl, { childList: true });

  /* === Clear → return to default === */
  /* === Predictive search === */
  var searchTimer = null;
  function predictiveSearch(query) {
    var gridContainer = resultsEl.querySelector('.ag-search-grid');
    if (!gridContainer) return;
    gridContainer.innerHTML = '<div class="ag-search-count" style="padding:12px 0 0;">Searching...</div>';

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=12', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = data.resources && data.resources.results && data.resources.results.products || [];
        if (products.length === 0) {
          gridContainer.innerHTML = '<div class="ag-search-count" style="padding:12px 0 0;">No results for "' + query + '"</div>';
          return;
        }
        var html = '';
        products.forEach(function(p) {
          if (hideOos && !p.available && !(p.tags && p.tags.indexOf('coming-soon') !== -1)) return;
          var img = p.image || '';
          var price = p.price;
          var comparePrice = p.compare_at_price_max || '';
          var onSale = comparePrice && parseFloat(comparePrice) > parseFloat(price);
          html += '<div class="ag-search-result">';
          html += '<a href="' + p.url + '" class="ag-search-result__link">';
          html += '<div class="ag-search-result__img"><img src="' + img + '" alt="' + (p.title || '') + '" width="200" height="200" loading="lazy"></div>';
          html += '<div class="ag-search-result__info">';
          html += '<p class="ag-search-result__title">' + p.title + '</p>';
          if (onSale) {
            html += '<p class="ag-search-result__price"><s>' + comparePrice + '</s> ' + price + '</p>';
          } else {
            html += '<p class="ag-search-result__price">' + price + '</p>';
          }
          html += '</div></a></div>';
        });
        gridContainer.innerHTML = '<div class="ag-search-results">' + html + '</div>';
      })
      .catch(function() {
        gridContainer.innerHTML = '<div class="ag-search-count" style="padding:12px 0 0;">Search failed. Try again.</div>';
      });
  }

  if (inputEl) {
    /* Stop Prestige's native search from intercepting */
    inputEl.addEventListener('input', function(e) {
      e.stopPropagation();
      clearTimeout(searchTimer);
      var q = inputEl.value.trim();
      if (q === '') {
        setTimeout(function() {
          if (inputEl.value.trim() === '') showDefault();
        }, 300);
        return;
      }
      if (q.length < 2) return;
      searchTimer = setTimeout(function() {
        predictiveSearch(q);
      }, 300);
    }, true);

    /* Also block keyup/keydown propagation */
    inputEl.addEventListener('keyup', function(e) { e.stopPropagation(); }, true);
    inputEl.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        var q = inputEl.value.trim();
        if (q.length >= 2) predictiveSearch(q);
      } else {
        e.stopPropagation();
      }
    }, true);
  }

})();